import { useLocation, useNavigate } from "react-router-dom";

import Header from "../../components/Header/Header";
import imgDone from "../../assets/img_done.svg";
import Button from "../../components/Buttons/Button";
import useSelectBrand from "../../hooks/styles/useSelectBrand";
import queryString from "query-string";
import { useEffect } from "react";

const RegistCompletePage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const location = useLocation();
  const receiptNumber = state?.receiptNumber || null;
  const queryParams = queryString.parse(location.search);

  const { hex } = useSelectBrand();

  useEffect(() => {
    const handlePopState = () => {
      if (queryParams.brandId) {
        navigate("/exit");
      } else {
        navigate(-2);
      }
    };

    window.history.pushState(null, "", location.pathname);

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <section className="p-hasHeader">
      <Header title="분실물 등록완료" />
      <div className="relative flex justify-center my-5 mb-8">
        <span>
          <svg
            width="278"
            height="299"
            viewBox="0 0 278 299"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_2116_71)">
              <path
                d="M130.904 290.589C131.608 285.562 129.82 281.155 126.91 280.746C124 280.336 121.07 284.08 120.366 289.107C119.662 294.133 121.45 298.54 124.36 298.95C127.27 299.359 130.2 295.616 130.904 290.589Z"
                fill="#4C3D38"
              />
              <path
                d="M146.512 298.948C149.422 298.538 151.21 294.132 150.506 289.105C149.802 284.078 146.872 280.335 143.962 280.744C141.052 281.153 139.264 285.56 139.968 290.587C140.672 295.614 143.602 299.357 146.512 298.948Z"
                fill="#4C3D38"
              />
              <path
                d="M156.647 277.216C156.647 283.908 154.042 291.465 135.439 291.465C116.835 291.465 114.23 283.908 114.23 277.216C114.23 270.524 119.868 252.66 135.439 252.66C151.009 252.66 156.647 270.517 156.647 277.216Z"
                fill="white"
              />
              <path
                d="M135.439 292.574C115.433 292.574 113.123 283.812 113.123 277.216C113.123 273.563 114.666 267.197 118.06 261.836C121.027 257.148 126.458 251.55 135.439 251.55C144.419 251.55 149.851 257.141 152.817 261.836C156.212 267.197 157.754 273.563 157.754 277.216C157.754 283.812 155.444 292.574 135.439 292.574ZM135.439 253.769C121.123 253.769 115.337 270.317 115.337 277.216C115.337 281.15 115.337 290.356 135.439 290.356C155.54 290.356 155.54 281.15 155.54 277.216C155.54 270.317 149.755 253.769 135.439 253.769Z"
                fill="#4C3D38"
              />
              <path
                d="M143.645 283.087C140.567 285.868 136.501 286.193 133.609 283.538C130.716 280.884 130.768 276.595 133.159 273.482C135.549 270.369 147.165 260.527 151.223 264.247C155.282 267.966 146.567 280.462 143.652 283.095L143.645 283.087Z"
                fill="white"
              />
              <path
                d="M138.184 286.452C136.258 286.452 134.391 285.757 132.856 284.352C129.646 281.409 129.402 276.551 132.28 272.802C133.616 271.057 137.151 267.848 140.759 265.496C141.269 265.163 141.955 265.304 142.294 265.822C142.626 266.332 142.486 267.019 141.97 267.36C138.258 269.778 135.048 272.846 134.044 274.155C131.882 276.972 132.015 280.573 134.361 282.718C136.752 284.906 140.184 284.722 142.914 282.267C144.117 281.18 146.877 277.726 148.965 273.771C149.253 273.231 149.925 273.024 150.463 273.312C151.002 273.6 151.209 274.273 150.921 274.813C148.884 278.666 146.006 282.466 144.39 283.923C142.516 285.609 140.324 286.467 138.191 286.467L138.184 286.452Z"
                fill="#4C3D38"
              />
              <path
                d="M127.233 284.566C130.31 287.347 134.376 287.672 137.269 285.017C140.162 282.363 140.11 278.074 137.719 274.961C135.328 271.848 123.713 262.006 119.654 265.725C115.595 269.445 124.311 281.941 127.225 284.574L127.233 284.566Z"
                fill="white"
              />
              <path
                d="M132.686 287.931C130.553 287.931 128.362 287.08 126.487 285.387C124.879 283.93 121.993 280.13 119.957 276.277C119.669 275.737 119.875 275.065 120.414 274.776C120.953 274.488 121.624 274.695 121.912 275.235C124.001 279.191 126.76 282.644 127.963 283.731C130.694 286.193 134.125 286.37 136.516 284.182C138.863 282.037 138.996 278.429 136.833 275.619C135.83 274.31 132.612 271.242 128.908 268.824C128.399 268.491 128.251 267.803 128.583 267.286C128.915 266.775 129.602 266.628 130.118 266.96C133.719 269.312 137.254 272.521 138.597 274.266C141.475 278.015 141.231 282.873 138.021 285.823C136.494 287.228 134.62 287.923 132.694 287.923L132.686 287.931Z"
                fill="#4C3D38"
              />
              <path
                d="M183.884 253.591C177.944 253.229 168.786 247.713 170.97 234.455C173.155 221.197 183.582 219.045 189.33 220.561C195.042 222.062 197.935 229.538 196.429 238.67C194.924 247.802 189.773 253.946 183.884 253.584V253.591Z"
                fill="#FFF56D"
              />
              <path
                d="M184.372 254.715C184.187 254.715 184.003 254.715 183.818 254.701C180.652 254.508 176.144 252.889 172.993 248.933C170.904 246.308 168.668 241.635 169.886 234.277C170.838 228.517 173.443 224.11 177.42 221.522C181.656 218.771 186.497 218.668 189.626 219.496C195.891 221.145 199.145 229.109 197.529 238.862C195.972 248.304 190.607 254.723 184.379 254.723L184.372 254.715ZM183.951 252.49C189.249 252.822 193.928 247.055 195.337 238.5C196.754 229.922 194.171 222.994 189.05 221.64C186.386 220.938 182.246 221.027 178.616 223.385C175.125 225.648 172.919 229.441 172.063 234.64C171.207 239.831 172.122 244.289 174.719 247.55C177.413 250.937 181.258 252.32 183.951 252.482V252.49Z"
                fill="#4C3D38"
              />
              <path
                d="M86.9854 253.591C92.9259 253.229 102.084 247.713 99.8994 234.455C97.7151 221.197 87.288 219.045 81.5394 220.561C75.8204 222.069 72.9276 229.538 74.433 238.677C75.9384 247.816 81.0893 253.954 86.9781 253.591H86.9854Z"
                fill="#FFF56D"
              />
              <path
                d="M86.4983 254.715C80.2627 254.715 74.9053 248.297 73.3482 238.854C71.7395 229.101 74.9864 221.138 81.2516 219.489C84.3731 218.668 89.2213 218.771 93.4571 221.515C97.4346 224.095 100.04 228.51 100.992 234.27C102.209 241.627 99.9731 246.301 97.8848 248.926C94.7338 252.882 90.2249 254.501 87.0592 254.693C86.8747 254.708 86.6902 254.708 86.5057 254.708L86.4983 254.715ZM84.9339 221.256C83.7753 221.256 82.7127 221.404 81.8124 221.64C76.6985 222.986 74.1083 229.922 75.5251 238.5C76.942 247.055 81.6279 252.815 86.9116 252.49C89.6051 252.327 93.4424 250.944 96.1432 247.558C98.7408 244.297 99.6558 239.831 98.7998 234.647C97.9438 229.449 95.7374 225.656 92.2469 223.393C89.8412 221.833 87.2068 221.263 84.9339 221.263V221.256Z"
                fill="#4C3D38"
              />
              <path
                d="M181.501 232.466C181.501 255.307 165.517 270.998 135.431 270.998C105.345 270.998 89.3616 255.307 89.3616 232.466C89.3616 209.625 106.401 191.109 135.439 191.109C164.477 191.109 181.508 209.625 181.508 232.466H181.501Z"
                fill="white"
              />
              <path
                d="M135.439 272.114C120.731 272.114 108.607 268.321 100.394 261.141C92.4609 254.205 88.262 244.289 88.262 232.473C88.262 220.657 92.697 210.068 100.755 202.422C109.315 194.296 121.307 190 135.439 190C149.57 190 161.562 194.296 170.122 202.415C178.18 210.061 182.615 220.731 182.615 232.466C182.615 244.201 178.424 254.198 170.483 261.134C162.27 268.313 150.153 272.107 135.439 272.107V272.114ZM135.439 192.218C121.883 192.218 110.422 196.3 102.275 204.027C94.6673 211.244 90.4758 221.345 90.4758 232.466C90.4758 255.898 107.286 269.888 135.439 269.888C163.591 269.888 180.401 255.898 180.401 232.466C180.401 221.345 176.21 211.244 168.602 204.027C160.462 196.3 148.995 192.218 135.439 192.218Z"
                fill="#4C3D38"
              />
              <path
                d="M169.03 247.188C169.03 257.791 156.95 265.762 135.439 265.762C113.928 265.762 101.847 257.791 101.847 247.188C101.847 236.584 114.23 227.985 135.439 227.985C156.647 227.985 169.03 236.584 169.03 247.188Z"
                fill="#FFF56D"
              />
              <path
                d="M135.439 266.879C114.363 266.879 100.74 259.152 100.74 247.195C100.74 241.479 104.069 236.326 110.12 232.665C116.377 228.879 125.129 226.883 135.439 226.883C145.748 226.883 154.5 228.887 160.757 232.665C166.808 236.326 170.137 241.479 170.137 247.195C170.137 259.152 156.514 266.879 135.439 266.879ZM135.439 229.094C116.311 229.094 102.954 236.533 102.954 247.188C102.954 257.843 115.706 264.653 135.439 264.653C155.171 264.653 167.923 257.799 167.923 247.188C167.923 236.577 154.566 229.094 135.439 229.094Z"
                fill="#4C3D38"
              />
              <path
                d="M135.439 255.107C131.801 255.107 130.029 253.562 129.838 253.392C129.387 252.978 129.358 252.275 129.779 251.824C130.192 251.38 130.885 251.343 131.336 251.75C131.409 251.809 132.686 252.889 135.446 252.889C138.206 252.889 139.505 251.795 139.556 251.75C140.014 251.351 140.707 251.388 141.113 251.839C141.519 252.29 141.49 252.978 141.047 253.392C140.855 253.569 139.084 255.107 135.446 255.107H135.439Z"
                fill="#4C3D38"
              />
              <path
                d="M144.973 246.959C144.847 248.297 144.08 249.332 142.648 249.332C141.217 249.332 140.449 248.297 140.324 246.959"
                fill="#FFF56D"
              />
              <path
                d="M142.648 250.441C140.759 250.441 139.416 249.118 139.224 247.062C139.165 246.456 139.615 245.909 140.22 245.857C140.826 245.798 141.372 246.249 141.423 246.863C141.504 247.772 141.918 248.23 142.641 248.23C143.364 248.23 143.777 247.772 143.858 246.863C143.918 246.249 144.441 245.805 145.061 245.857C145.666 245.916 146.117 246.456 146.058 247.062C145.866 249.118 144.523 250.441 142.633 250.441H142.648Z"
                fill="#4C3D38"
              />
              <path
                d="M130.546 246.959C130.421 248.297 129.653 249.332 128.221 249.332C126.79 249.332 126.022 248.297 125.897 246.959"
                fill="#FFF56D"
              />
              <path
                d="M128.221 250.441C126.332 250.441 124.989 249.118 124.797 247.062C124.738 246.456 125.189 245.909 125.794 245.857C126.399 245.798 126.945 246.249 126.997 246.863C127.078 247.772 127.491 248.23 128.214 248.23C128.937 248.23 129.351 247.772 129.432 246.863C129.491 246.249 130.022 245.805 130.635 245.857C131.24 245.916 131.69 246.456 131.631 247.062C131.439 249.118 130.096 250.441 128.207 250.441H128.221Z"
                fill="#4C3D38"
              />
              <path
                d="M148.95 253.443C148.655 253.443 148.353 253.355 148.087 253.162C147.423 252.689 147.275 251.765 147.748 251.099L150.648 247.055C150.928 246.67 151.371 246.441 151.843 246.441C152.315 246.441 152.766 246.67 153.039 247.055L154.743 249.428L156.448 247.055C156.728 246.67 157.171 246.441 157.643 246.441C158.116 246.441 158.566 246.67 158.839 247.055L161.739 251.099C162.211 251.765 162.064 252.689 161.399 253.162C160.735 253.643 159.813 253.488 159.341 252.822L157.636 250.449L155.931 252.822C155.651 253.207 155.208 253.436 154.736 253.436C154.264 253.436 153.813 253.207 153.54 252.822L151.836 250.449L150.131 252.822C149.843 253.222 149.393 253.436 148.928 253.436L148.95 253.443Z"
                fill="#FDBA4D"
              />
              <path
                d="M110.319 253.443C110.024 253.443 109.721 253.355 109.456 253.162C108.792 252.689 108.644 251.765 109.116 251.099L112.016 247.055C112.297 246.67 112.74 246.441 113.212 246.441C113.684 246.441 114.134 246.67 114.407 247.055L116.112 249.428L117.817 247.055C118.097 246.67 118.54 246.441 119.012 246.441C119.484 246.441 119.934 246.67 120.207 247.055L123.108 251.099C123.58 251.765 123.432 252.689 122.768 253.162C122.104 253.643 121.182 253.488 120.709 252.822L119.005 250.449L117.3 252.822C117.02 253.207 116.577 253.436 116.105 253.436C115.632 253.436 115.182 253.207 114.909 252.822L113.204 250.449L111.5 252.822C111.212 253.222 110.762 253.436 110.297 253.436L110.319 253.443Z"
                fill="#FDBA4D"
              />
              <path
                d="M135.439 251.225C136.4 251.225 137.18 250.517 137.18 249.643C137.18 248.769 136.4 248.06 135.439 248.06C134.477 248.06 133.697 248.769 133.697 249.643C133.697 250.517 134.477 251.225 135.439 251.225Z"
                fill="#FDBA4D"
              />
              <path
                d="M135.896 234.24C132.266 234.24 129.823 231.638 129.823 227.77C129.823 223.541 131.867 221.115 135.439 221.115C137.07 221.115 138.383 221.626 139.357 222.624C140.531 223.837 141.121 225.744 141.054 228.147C141.04 228.746 140.545 229.227 139.948 229.227C139.94 229.227 139.925 229.227 139.918 229.227C139.306 229.212 138.826 228.702 138.841 228.088C138.892 226.299 138.523 224.946 137.771 224.169C137.225 223.607 136.464 223.334 135.439 223.334C134.597 223.334 132.037 223.334 132.037 227.77C132.037 229.826 133.048 232.022 135.896 232.022C137.239 232.022 138.295 231.527 138.966 230.58C139.32 230.077 140.014 229.966 140.508 230.314C141.003 230.662 141.121 231.364 140.774 231.859C139.689 233.39 137.955 234.24 135.896 234.24Z"
                fill="#4C3D38"
              />
            </g>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M138.97 18C72.1601 18 18 72.1601 18 138.97C18 172.816 31.8883 203.402 54.2998 225.369C57.8496 228.848 57.9068 234.546 54.4275 238.096C50.9482 241.646 45.25 241.703 41.7002 238.224C15.9769 213.011 0 177.848 0 138.97C0 62.219 62.219 0 138.97 0C215.721 0 277.94 62.219 277.94 138.97C277.94 177.336 262.381 212.085 237.25 237.223C233.736 240.738 228.038 240.739 224.522 237.225C221.007 233.711 221.006 228.012 224.521 224.497C246.415 202.597 259.94 172.371 259.94 138.97C259.94 72.1601 205.78 18 138.97 18Z"
              fill={`${hex}`}
            />
            <defs>
              <clipPath id="clip0_2116_71">
                <rect
                  width="125"
                  height="109"
                  fill="white"
                  transform="translate(72.9351 190)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
        <p className="absolute text-2xl font-medium text-center inset-y-1/3">
          분실물 등록이 <br /> 완료되었습니다.
        </p>
      </div>

      <div className="mb-12 text-center">
        <p className="inline-flex items-center h-10 mb-2 px-5 bg-white rounded-[30px] border-2 border-gray-200 text-neutral-500 font-semibold">
          접수번호
        </p>
        <p className="text-3xl font-bold">{receiptNumber}</p>
      </div>

      <ul className="list-decimal mb-10 py-5 pl-10 pr-5 bg-slate-50 rounded-[20px] border border-violet-50 ">
        <li>물품 미습득 시 별도 연락은 드리지 않습니다.</li>
        <li>습득여부 확인까지 시간이 다소 소요됩니다.</li>
        <li>
          분실물 수령 시 본인확인이 필요합니다. <br />
          (신분증, 구매영수증, 연락처 현장 확인 등)
        </li>
      </ul>

      {queryParams.brandId ? (
        <Button
          onClick={() => navigate("/exit", { state: { restart: false } })}
          arrow
        >
          프로그램 종료
        </Button>
      ) : (
        <Button onClick={() => navigate("/landing")} arrow>
          처음으로 돌아가기
        </Button>
      )}
    </section>
  );
};

export default RegistCompletePage;
